// src/config.js
const Config = {
   // API_BASE_URL: "http://65.1.220.25",
  //API_BASE_URL: "http://13.200.60.205",
    local_public_endpoint:"http://localhost:8280/public",
    local_private_endpoint:"http://localhost:8280/private",

  //  local_public_endpoint:"https://lililaundry.in/public",
  // local_private_endpoint:"https://lililaundry.in/private",
   // API_BASE_URL: "http://localhost",
    public : "/public",
    ENCRYPT_DECRYPT_KEY:"RFLECTSU_!@#45$%67890QWERTYUIOPASDFGHJKLZXCVBNM_#45$%67890QWERTY_scbacakjgcuyweqtdutu"
  };

  export default Config;
